import { Building } from "./building";
import { Module } from "./module";
import { ModuleType } from "./module-type";
import { AddModuleParameters } from "./add-module-parameters";

export enum ModuleTypeFamily {
  TestType = "TestType",
  Basdata = "Basdata",
  Ventilation = "Ventilation",
  VärmePrimar = "VärmePrimar",
  VärmeSekundar = "VärmeSekundar",
  VärmeEl = "VärmeEl",
  Kyla = "Kyla",
}

export enum ModuleTypeId {
  Byggnadsdata = "Byggnadsdata",
  Lokaler = "Lokaler",
  VentilationFTX = "VentilationFTX",
  VentilationFT = "VentilationFT",
  VentilationFX = "VentilationFX",
  VentilationF = "VentilationF",
  VentilationS = "VentilationS",
  VarmePrimarFjarr = "VarmePrimarFjarr",
  VarmePrimarPump = "VarmePrimarPump",
  VarmePrimarLuftburen = "VarmePrimarLuftburen",
  VarmePrimarAnnatSystem = "VarmePrimarAnnatSystem",
  VarmePrimarSaknas = "VarmePrimarSaknas",
  VarmeSekundarVatten = "VarmeSekundarVatten",
  VarmeSekundarSaknas = "VarmeSekundarSaknas",
  VarmeElVarmepump = "VarmeElVarmepump",
  VarmeElStralningsvarmare = "VarmeElStralningsvarmare",
  VarmeElGolvvarme = "VarmeElGolvvarme",
  VarmeElAirotemper = "VarmeElAirotemper",
  VarmeElRadiatorer = "VarmeElRadiatorer",
  KylaVattenburet = "KylaVattenBuret",
  KylaMaskin = "KylaMaskin",
  KylaAnnatSystem = "KylaAnnatSystem",
  KylaSaknas = "KylaSaknas",
}

export enum BFLType {
  BFV_J3 = "BFV_J3",
  BFV_J4 = "BFV_J4",
  BFV_J5 = "BFV_J5",
  BFV_J6 = "BFV_J6",
  BFV_J8 = "BFV_J8",
  BFV_J9 = "BFV_J9",
  BFV_J10 = "BFV_J10",
  BFV_J11 = "BFV_J11",
  BFV_J12 = "BFV_J12",
  BFV_J13 = "BFV_J13",
  BFK_J1 = "BFK_J1",
  BFL_J3_FTX_FT = "BFL_J3_FTX_FT",
  BFL_J3_FX_F = "BFL_J3_FX_F",
  BFL_J4_FTX = "BFL_J4_FTX",
  BFL_J5_FTX_FT = "BFL_J5_FTX_FT",
  BFL_J3_S = "BFL_J3_S",
  Unknown = "Unknown",
  NotYetImplemented = "NotYetImplemented",
}

export enum ModuleStatuses {
  Created = "Created",
  Configured = "Configured",
}

export interface DBBuilding extends Building {
  modules: DBModule[];
}
export interface DBModule extends Module {
  moduleTypeId: ModuleTypeId;
  status: ModuleStatuses;
}
export interface DBModuleType extends ModuleType {
  id: ModuleTypeId;
  family: ModuleTypeFamily;
}
export interface DBAddModuleParameters extends AddModuleParameters {}
